import { Link as RouterLink, Outlet } from 'react-router-dom';

// material-ui
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Toolbar from '@mui/material/Toolbar';

// project imports
import AuthFooter from 'components/cards/AuthFooter';
import ContainerWrapper from 'components/ContainerWrapper';
import LogoSection from 'components/logo';
import useAuth from 'contexts/AuthContext';
import { APP_DEFAULT_PATH } from 'config';
import marketingContent from 'pages/marketing/marketingContent';

// ==============================|| PUBLIC LAYOUT ||============================== //
// The marketing site's shell — no sidebar, no authenticated-user chrome.
// Deliberately separate from DashboardLayout, which assumes a logged-in
// session (drawer, profile menu, breadcrumbs tied to menu-items).

export default function PublicLayout() {
  const { user } = useAuth();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar position="static" color="inherit" elevation={0} sx={{ borderBottom: '1px solid', borderColor: 'divider' }}>
        <ContainerWrapper>
          <Toolbar disableGutters sx={{ justifyContent: 'space-between' }}>
            <LogoSection to="/" />
            <Stack direction="row" sx={{ gap: 2, alignItems: 'center' }}>
              <Button component={RouterLink} to="/catalog" color="secondary" sx={{ display: { xs: 'none', sm: 'inline-flex' } }}>
                Courses
              </Button>
              <Link
                href={`mailto:${marketingContent.contactEmail}`}
                underline="hover"
                color="text.secondary"
                variant="body2"
                sx={{ display: { xs: 'none', sm: 'inline' } }}
              >
                {marketingContent.ctaLabels.contact}
              </Link>
              {user ? (
                <Button component={RouterLink} to={APP_DEFAULT_PATH} variant="contained">
                  Go to dashboard
                </Button>
              ) : (
                <>
                  <Button component={RouterLink} to="/login" color="secondary">
                    Log in
                  </Button>
                  <Button component={RouterLink} to="/signup" variant="contained">
                    Sign up
                  </Button>
                </>
              )}
            </Stack>
          </Toolbar>
        </ContainerWrapper>
      </AppBar>

      <Box sx={{ flexGrow: 1 }}>
        <Outlet />
      </Box>

      <AuthFooter />
    </Box>
  );
}
